<div class="container-fluid">
  <div class="card">
    <div class="card-body">
      <ng-content content></ng-content>
      <footer class="row">
        <div class="col-12 col-md-12">
          <ng-content buttons></ng-content>
          <div class="mb-1">
            <small *ngIf="isEdit"
              >Última atualização em
              {{ ultimaAtualizacao }}</small
            >
            <small *ngIf="isEdit && lastUser"> pelo usuário 
              {{ ultimoUsuario }}</small>
          </div>
          <button
            *ngIf="typePage != 'visualizar' && !isView"
            type="submit"
            (click)="submit()"
            title="Salvar"
            [disabled]="!canSubmit"
            class="btn rounded-pill btn-primary float-right mb-2 col-md-auto"
          >
            <em class="fa fa-check"></em>
            {{ pageId ? "Atualizar" : "Salvar" }} &nbsp;
            <em
              class="fa fa-spinner fa-spin"
              *ngIf="buttonSubmit.buttonSubmited"
            ></em>
          </button>
          <a [routerLink]="pathBack">
            <button
              *ngIf="!isView"
              type="submit"
              title="Cancelar"
              class="btn rounded-pill btn-outline-danger float-left mb-2 col-md-auto"
            >
              <em class="fa fa-times"></em>
              Cancelar
            </button>
            <a [routerLink]="pathBack">
              <button
                *ngIf="isView"
                type="submit"
                title="Voltar"
                class="btn rounded-pill btn-outline-danger float-left mb-2 col-md-auto"
              >
                <em class="fa fa-arrow-left"></em>
                Voltar
              </button>
            </a>
          </a>
        </div>
      </footer>
    </div>
  </div>
</div>
